// perfect-scrollbar 1.4.0 — exposes the `PerfectScrollbar` global used by the
// theme JS (main.js/app.js). Stylesheet stays local.
import PerfectScrollbar from "perfect-scrollbar";

window.PerfectScrollbar = PerfectScrollbar;
